"use client";
import { j as l } from "./jsx-runtime-CJ-St4mQ.mjs";
import { useMemo as u } from "react";
import { t as m } from "./tv.config-BuYIgndg.mjs";
const c = m({
  base: [
    "bg-gray-300",
    // "transition-all",
    // "duration-150",
    "size-24"
  ],
  variants: {
    variant: {
      circle: ["rounded-full"],
      square: ["rounded-none"],
      rounded: ["rounded-md"]
    },
    hasChild: {
      true: ["flex", "items-center", "justify-center", "text-gray-400"]
    },
    isAnimate: {
      true: ["animate-pulse"],
      false: []
    }
  },
  defaultVariants: {
    isAnimate: !0
  }
}), x = (i) => {
  const {
    variant: t = "rounded",
    className: a,
    size: e,
    width: s,
    children: r,
    isAnimate: n,
    ...o
  } = i, d = u(() => t === "circle" ? {
    height: `${e}px`,
    width: `${e}px`
  } : {
    height: `${e}px`,
    width: `${s}%`
  }, [e, t, s]);
  return /* @__PURE__ */ l.jsx(
    "div",
    {
      className: c({
        variant: t,
        class: a,
        hasChild: !!r,
        isAnimate: n
      }),
      style: d,
      ...o,
      children: r
    }
  );
};
export {
  x as default
};
